import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import NeonButton from "./NeonButton";

const FinalCTASection: React.FC = () => {
  const { t } = useTranslation("home");

  return (
    <section className="relative py-24 md:py-32 overflow-hidden bg-space">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div
          className="w-[400px] h-[400px] md:w-[600px] md:h-[600px] rounded-full animate-portal-spin opacity-40"
          style={{
            background:
              "conic-gradient(from 0deg, #00FF87, #60EFFF, #00FF87, #60EFFF, #00FF87)",
            filter: "blur(1px)",
          }}
        />
        <div
          className="absolute w-[200px] h-[200px] md:w-[300px] md:h-[300px] rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(0,255,135,0.3) 0%, rgba(11,15,25,0.95) 70%)",
          }}
        />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center">
        <motion.h2
          className="text-h1 md:text-display mb-6 text-white"
          style={{ lineHeight: "125%" }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {t("final_title")}
        </motion.h2>
        <motion.p
          className="text-body-lg text-gray-400 mb-10"
          style={{ lineHeight: "125%" }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          {t("final_subtitle")}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <NeonButton
            to="/products"
            size="lg"
            breathe
            variant="gradient"
            ariaLabel={t("final_cta")}
          >
            {t("final_cta")}
          </NeonButton>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
